<template>
  <v-container fluid>
    <transition name="fade">
      <div v-if="!showForm">
        <v-card elevation="1">
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">{{ $route.name }}</h3>
          </v-toolbar>
          <v-card-text style="padding: 20px">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    class="headline"
                    outlined
                    label="Digite a Senha Aqui:"
                    v-model="code"
                    @keydown.enter="checkCodeAndOpenForm(code)"
                    :loading="loader"
                    :disabled="loader"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card elevation="1" class="mt-6">
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">Abastecimentos do dia</h3>
            <v-spacer />
            <v-btn icon @click="initialize">
              <v-icon>mdi-update</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="padding: 20px">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-data-table
                    :items="current_supplies"
                    :headers="headers"
                    :loading="loader"
                  >
                    <template v-slot:item.datehour="{ item }">
                      <span>{{ convertDateTime(item.datehour) }}</span>
                    </template>
                    <template v-slot:item.supply_liters_stocked="{ item }">
                      <span>{{
                        item.supply_liters_stocked
                          ? realMaskII(item.supply_liters_stocked.toFixed(3))
                          : 0
                      }}</span>
                    </template>
                    <template v-slot:item.supply_price_day="{ item }">
                      <span>{{
                        item.supply_price_day
                          ? realMaskII(item.supply_price_day.toFixed(3))
                          : 0
                      }}</span>
                    </template>
                    <template v-slot:item.supply_value="{ item }">
                      <span>{{
                        item.supply_value
                          ? realMask(item.supply_value.toFixed(2))
                          : 0
                      }}</span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </div>
      <v-card elevation="1" class="mt-6" v-else>
        <v-toolbar color="secondary" dark shaped>
          <h3 class="title">Abastecer</h3>
        </v-toolbar>
        <v-card-text style="padding: 20px">
          <v-container>
            <v-alert type="warning" v-if="message">{{ message }}</v-alert>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    :items="prefectures"
                    label="Prefeitura/Município"
                    item-value="prefecture_id"
                    item-text="prefecture_social_name"
                    v-model="data.prefecture_id"
                    readonly
                    append-icon
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6" v-if="!data.supply_extra">
                  <v-autocomplete
                    label="Veículo:"
                    :rules="fieldRules"
                    :items="vehicles"
                    item-value="vehicle_id"
                    v-model="data.vehicle_id"
                    readonly
                    append-icon
                  >
                    <template slot="selection" slot-scope="{ item }"
                      >{{ item.brand_desc }} - {{ item.model_desc }} -
                      {{ item.vehicle_board }}</template
                    >
                    <template slot="item" slot-scope="{ item }"
                      >{{ item.brand_desc }} - {{ item.model_desc }} -
                      {{ item.vehicle_board }}</template
                    >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    label="Item:"
                    :rules="fieldRules"
                    :items="items"
                    item-value="item_id"
                    item-text="item_name"
                    v-model="data.item_id"
                    @change="loadBidding(data.item_id)"
                  >
                    <template slot="selection" slot-scope="{ item }"
                      >{{ item.item_description_desc }} preço R$:
                      {{ realMaskII(item.item_price.toFixed(3)) }}</template
                    >
                    <template slot="item" slot-scope="{ item }"
                      >{{ item.item_description_desc }} preço R$:
                      {{ realMaskII(item.item_price.toFixed(3)) }}</template
                    >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    label="Motorista:"
                    :items="drivers"
                    item-value="driver_id"
                    item-text="driver_name"
                    v-model="data.driver_id"
                    append-icon="mdi-plus"
                    @click:append="showDriverForm = true"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Preço Licitado"
                    v-model="data.supply_bidding_price"
                    v-mask-decimal.br="3"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Preço do dia"
                    v-model="data.supply_price_day"
                    v-mask-decimal.br="3"
                    :rules="fieldRules"
                    @input="calculateTotals"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Litros Abastecidos"
                    :rules="fieldRules"
                    v-model="data.supply_liters_stocked"
                    v-mask-decimal.br="3"
                    @input="calculateTotals"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Total"
                    v-model="data.supply_value"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Litros Autorizados"
                    v-model="data.supply_authorized_liters"
                    v-mask-decimal.br="3"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Valor Autorizado"
                    v-model="data.supply_authorized_value"
                    v-mask-decimal.br="2"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="KM"
                    v-if="!data.supply_extra"
                    v-model="data.supply_km"
                    v-mask-number
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    :rules="fieldRules"
                    label="N Cupom Fiscal"
                    v-model="data.supply_coupon"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-footer style="padding: 10px">
          <v-spacer />
          <v-btn
            color="error"
            class="mr-4"
            depressed
            large
            @click="
              () => {
                showForm = false;
                code = '';
              }
            "
            >Cancelar</v-btn
          >
          <v-btn
            :disabled="!valid && loader ? true : false"
            depressed
            large
            color="primary"
            class="mr-4"
            :loading="loader"
            @click="validate"
            >Confirmar</v-btn
          >
        </v-footer>
      </v-card>
    </transition>
    <v-dialog v-model="showDriverForm" width="500">
      <v-card>
        <v-toolbar color="secondary" dark shaped>
          <h3 class="title">Cadastrar Motorista</h3>
        </v-toolbar>
        <v-card-text>
          <v-form @submit.prevent="newDriver">
            <v-text-field
              class="mb-6 mt-6"
              :rules="fieldRules"
              label="nome do motorista"
              v-model="driver_name"
            />
            <v-footer absolute>
              <v-spacer />
              <v-btn
                text
                color="error"
                @click="[(showDriverForm = false), (driver_name = '')]"
                >Cancelar</v-btn
              >
              <v-btn
                text
                color="primary"
                :disabled="driver_name ? false : true"
                :loading="loader"
                @click="newDriver"
                >Confirmar</v-btn
              >
            </v-footer>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  props: ["id"],
  mixins: [Helpers],
  data: () => ({
    retorno: [],
    valid: false,
    loader: false,
    code: "",
    showForm: false,
    showDriverForm: false,
    total: 0,
    current_supplies: [],
    prefectures: [],
    items: [],
    vehicles: [],
    drivers: [],
    driver_name: "",
    message: "",
    headers: [
      { text: "Data/Hora", value: "datehour" },
      { text: "Prefeitura", value: "prefecture_social_name" },
      { text: "Litros Abastecidos", value: "supply_liters_stocked" },
      { text: "Preço do Dia", value: "supply_price_day" },
      { text: "Valor Abastecido", value: "supply_value" },
      { text: "Status", value: "supply_status" },
      { text: "Número do Cupom", value: "supply_coupon" },
    ],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      supply_id: null,
      supply_price_day: 0,
      supply_liters_stocked: 0,
      supply_authorized_liters: 0,
      supply_value: 0,
      supply_extra: false,
      supply_bidding_price: 0,
      supply_authorized_value: 0,
      supply_adjusted: false,
      supply_billed: false,
      supply_status: "CONCLUIDO",
      item_id: null,
      vehicle_id: null,
      provider_id: null,
      prefecture_id: null,
    },
  }),
  beforeCreate() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/login");
    }
  },
  created() {
    this.Helpers;
    this.$http.get(`/prefectures`).then((pf) => (this.prefectures = pf.data));
    this.$http.get(`/vehicles`).then((v) => (this.vehicles = v.data));
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.current_supplies = [];
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/supplies/attendants/${this.$store.getters.getUserData.table_id}`)
        .then((r) => {
          this.current_supplies = r.data;
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    newDriver() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .post("/supplies/drivers", {
          driver_name: this.driver_name,
          prefecture_id: this.data.prefecture_id,
        })
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
          this.$http
            .get(`/drivers/prefectures/${this.data.prefecture_id}`)
            .then((d) => {
              this.drivers = d.data;
              const driverItems = d.data.filter((f) =>
                f.driver_name === this.driver_name ? f : null
              );
              this.data.driver_id = driverItems[0].driver_id;
              this.showDriverForm = false;
            });
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.color = "error";
          this.snack.message = e.message;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    async checkCodeAndOpenForm(code) {
      try {
        const res = await this.$http.get(`/supplies/single/code/${code}`);
        if (res.data && res.data.length > 0) {
          this.data.supply_extra = true;
          this.data.prefecture_id = res.data[0].prefecture_id;
          this.data.item_billing_price =
            res.data[0].item_billing_price.toFixed(3);
          await this.$http
            .get(`/attendants/${this.$store.getters.getUserData.table_id}`)
            .then((r) => {
              this.$http.get(`/providers/${r.data[0].provider_id}`).then(() => {
                this.$http
                  .get(
                    `/supplies/providers/prefectures/${r.data[0].provider_id}/${this.data.prefecture_id}`
                  )
                  .then((i) => {
                    this.items = i.data.filter((f) => {
                      if (f.item_id == res.data[0].item_id) {
                        return f;
                      }
                    });
                    this.data.item_id = this.items[0].item_id;
                    this.loadBidding(this.items[0].item_id);
                  });
                this.data.provider_id = r.data[0].provider_id;
                this.data.vehicle_id = res.data[0].vehicle_id;
                this.data.driver_id = res.data[0].driver_id;
                this.data.supply_authorized_liters =
                  res.data[0].supply_authorized_liters.toFixed(3);
                this.data.supply_authorized_value =
                  res.data[0].supply_authorized_value.toFixed(2);
                this.data.supply_id = res.data[0].supply_id;

                if (this.data.supply_authorized_liters > 0) {
                  this.message = `ATENCÃO abastecimento com limite de ${this.realMaskII(
                    this.data.supply_authorized_liters
                      ? this.data.supply_authorized_liters
                      : 0
                  )} Litros apenas.`;
                } else if (this.data.supply_authorized_value > 0) {
                  this.message = `ATENCÃO abastecimento com limite de ${this.realMask(
                    this.data.supply_authorized_value
                      ? parseFloat(this.data.supply_authorized_value).toFixed(2)
                      : 0
                  )} Reais apenas.`;
                } else {
                  this.message = null;
                }
              });
              this.showForm = true;
            });
        } else {
          const res = await this.$http.get(`/vehicles/code/${code}`);
          if (res.data && res.data.length > 0) {
            await this.$http
              .get(`/attendants/${this.$store.getters.getUserData.table_id}`)
              .then(async (r) => {
                this.data.vehicle_id = res.data[0].vehicle_id;
                await this.$http
                  .get(`/vehicles/${res.data[0].vehicle_id}`)
                  .then(async (veh) => {
                    this.data.prefecture_id = veh.data[0].prefecture_id;
                    this.$http
                      .get(`/drivers/prefectures/${veh.data[0].prefecture_id}`)
                      .then((d) => (this.drivers = d.data));
                  });

                const retornoProvider = await this.$http.get(
                  `/providers/checkItems/${r.data[0].provider_id}/${this.data.prefecture_id}`
                );

                if (retornoProvider.data.length == 0) {
                  this.snack.show = true;
                  this.snack.color = "warning";
                  this.snack.message = "Veículo não encontrado!";
                  this.loader = false;
                  this.showForm = false;
                  return false;
                } else
                  this.$http
                    .get(`/providers/${r.data[0].provider_id}`)
                    .then((p) => {
                      this.$http
                        .get(
                          `/supplies/providers/${p.data[0].provider_id}/${res.data[0].vehicle_id}/${this.data.prefecture_id}`
                        )
                        .then((i) => {
                          this.items = i.data;
                          this.data.item_id = i.data[0].item_id;
                          this.loadBidding(i.data[0].item_id);
                          this.data.prefecture_id = res.data[0].prefecture_id;
                          this.data.item_billing_price =
                            i.data[0].item_billing_price.toFixed(3);
                        });
                      this.data.provider_id = r.data[0].provider_id;
                      this.data.supply_extra = false;
                      this.showForm = true;
                    });
              });
          } else {
            this.snack.show = true;
            this.snack.color = "warning";
            this.snack.message =
              "SENHA INEXISTENTE OU INATIVA. ENTRE EM CONTATO COM O SUPORTE.      " +
              "Possiveis causas: " +
              "Veículo Inativo, Código inválido, Código já utilizado anteriormente.";
            this.loader = false;
            this.showForm = false;
          }
        }
      } catch (error) {
        this.snack.show = true;
        this.snack.color = "error";
        this.snack.message = "Erro ao processar requisição " + error;
        this.loader = false;
        this.showForm = false;
      }
    },
    loadBidding(item_id) {
      const dataItem = [...this.items];
      this.data.supply_bidding_price = dataItem
        .find((v) => v.item_id === item_id)
        .item_billing_price.toFixed(3);
    },
    calculateTotals() {
      if (this.data.supply_price_day && this.data.supply_liters_stocked) {
        let price_day = this.convertDecimalNumberII(this.data.supply_price_day);
        let liters_stocked = this.convertDecimalNumberII(
          this.data.supply_liters_stocked
        );
        this.data.supply_value = (price_day * liters_stocked).toFixed(2);
      }
    },
    checkLitersAndValuesAutirized() {
      if (this.data.message) {
        if (this.data.supply_authorized_liters) {
          if (
            this.data.supply_authorized_liters ==
            this.data.supply_liters_stocked
          ) {
            return true;
          } else {
            return false;
          }
        } else if (this.data.supply_authorized_value) {
          if (this.data.supply_authorized_value == this.data.supply_value) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      delete this.data.item_billing_price;
      delete this.data.datehour;
      this.$store.dispatch("setLoader", this.loader);
      if (!this.data.supply_extra) {
        this.$http
          .post(`/supplies/vehicle/check`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.error ? r.data.error : r.data.success;
            this.snack.color = `${r.data.error ? "warning" : "success"}`;
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            if (r.data.success) {
              setTimeout(() => {
                this.data = {
                  supply_id: null,
                  supply_price_day: 0,
                  supply_adjusted: false,
                  supply_liters_stocked: false,
                  item_id: null,
                  vehicle_id: null,
                  supply_status: "CONCLUIDO",
                  supply_extra: false,
                  supply_authorized_value: 0,
                  supply_billed: false,
                };
                this.data.supply_bidding_price = 0;
                this.showForm = false;
                this.initialize();
              }, 1500);
            }
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        if (
          parseFloat(
            this.convertDecimalNumberII(this.data.supply_authorized_liters)
          ) &&
          parseFloat(
            this.convertDecimalNumberII(this.data.supply_authorized_liters)
          ) <
            parseFloat(
              this.convertDecimalNumberII(this.data.supply_liters_stocked)
            )
        ) {
          this.snack.show = true;
          this.snack.message =
            "O valor de litros ultrapassou o autorizado!".toUpperCase();
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        } else if (
          parseFloat(
            this.convertDecimalNumberII(this.data.supply_authorized_value)
          ) &&
          parseFloat(
            this.convertDecimalNumberII(this.data.supply_authorized_value)
          ) < parseFloat(this.convertDecimalNumberII(this.data.supply_value))
        ) {
          this.snack.show = true;
          this.snack.message =
            "O valor ultrapassou o autorizado!".toUpperCase();
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        } else {
          this.data.supply_status = "CONCLUIDO";
          this.$http
            .put(`/supplies/extra/${this.data.supply_id}`, this.data)
            .then((r) => {
              this.snack.show = true;
              this.snack.message = r.data.error ? r.data.error : r.data.result;
              this.snack.color = `${r.data.error ? "warning" : "success"}`;
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
              if (r.data.result) {
                setTimeout(() => {
                  this.data = {
                    supply_id: null,
                    supply_price_day: 0,
                    supply_adjusted: false,
                    supply_liters_stocked: false,
                    item_id: null,
                    vehicle_id: null,
                  };
                  this.data.supply_bidding_price = 0;
                  this.showForm = false;
                  this.initialize();
                }, 1500);
              }
            })
            .catch((e) => {
              this.snack.show = true;
              this.snack.message = e.message;
              this.snack.color = "error";
              this.loader = false;
              this.$store.dispatch("setLoader", false);
            });
        }
      }
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}

.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter {
  opacity: 0;
}
</style>
